export const FETCH_ACTIVITY = "FETCH_ACTIVITY";
export const TEST_ATTENDED = "TEST_ATTENDED";
